import { render } from "./tagEdit.vue?vue&type=template&id=bf34ac6c&scoped=true"
import script from "./tagEdit.vue?vue&type=script&lang=js"
export * from "./tagEdit.vue?vue&type=script&lang=js"

import "./tagEdit.vue?vue&type=style&index=0&id=bf34ac6c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf34ac6c"],['__file',"src/views/active/components/tagEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf34ac6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf34ac6c', __exports__)) {
    console.log('reload')
    api.reload('bf34ac6c', __exports__)
  }
  
  module.hot.accept("./tagEdit.vue?vue&type=template&id=bf34ac6c&scoped=true", () => {
    console.log('re-render')
    api.rerender('bf34ac6c', render)
  })

}


export default __exports__